import React from 'react';
import { Icon } from 'components';
import styles from 'styles/sidebar.module.scss';
import {
	faChartLine,
	faLightbulb,
	faUsers,
	faCog
} from '@fortawesome/fontawesome-pro-solid';
import useReactRouter from 'use-react-router';
import { USER_SHIELD_ICON } from 'lib/globals';

const SideBar = () => {

	return (
		<div className={styles.sidebar} >
			<div className={styles.logo}>
				<img src={"https://monsterocu-prod-publicfiles.s3.eu-central-1.amazonaws.com/shipprotect-logo.png"} />
			</div>
			<div className={styles.menu}>
				<MenuItem pathto="/" activeRoutes={['/', '/dashboard']} icon={faChartLine}>
					Dashboard
				</MenuItem>
				<MenuItem pathto="/settings" activeRoutes={['/settings']} icon={faCog}>
					Settings
				</MenuItem>


				 <div className={styles.spacer}></div>

				<MenuItem icon={faUsers} onClick={() => { window.open("https://www.facebook.com/groups/ecom.monsterapps") }}>
					Facebook Group
				</MenuItem>
				<MenuItem icon={faLightbulb} onClick={() => { window.open("https://shipprotect.feedbear.com/boards/feature-requests") }}>
					Feature Suggestion
				</MenuItem>
			{/*	<MenuItem icon={faQuestionCircle} onClick={() => { window.open("https://monsterapps.crisp.help/en/category/monsterupsells-48n04z") }}>
					Faq
				</MenuItem>*/}
				<MenuItem icon={USER_SHIELD_ICON} onClick={() => { window.open("https://monsterapps.crisp.help/en/article/privacy-policy-monsterupsells-76n8in") }}>
					Privacy Policy
				</MenuItem> 
			</div>
		</div>
	);
};

const MenuItem = ({ pathto, activeRoutes = false, children, icon, onClick, badge }) => {
	const { history, location } = useReactRouter();
	const active = (activeRoutes || [pathto]).includes(location.pathname);
	return (
		<div
			className={styles.menu_item}
			data-active={active}
			pathto={pathto}
			onClick={() => {
				if (onClick) onClick()
				else if (!active) history.push(pathto + location.search);
			}}
		>
			<div>
				<Icon icon={icon} size="lg" />
				<span className={styles.text}>{children}</span>
			</div>
			{
				badge &&
				<SideBarBadge>{badge}</SideBarBadge>
			}
		</div>
	);
};

export const SideBarBadge = ({ children, style, className = '' }) => <div className={`${styles.badge} ${className}`} style={style}>{children}</div>

export default SideBar;
